import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITipoPrecioExtra } from '@appNeo/core/interfaces/ITipoPrecioExtra';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, catchError, map, Observable, of, Subject, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TiposPrecioExtraService {

  urlTiposPrecioExtra       = environment.api_base_url_backoffice+ '/tiposPrecioExtra';

  public tipoPrecioExtra$: BehaviorSubject<ITipoPrecioExtra> = new BehaviorSubject<ITipoPrecioExtra>(null);
  public tiposPrecioExtra$: BehaviorSubject<ITipoPrecioExtra[]> = new BehaviorSubject<ITipoPrecioExtra[]>([]);
  public totalTiposPrecioExtra$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  set tipoPrecioExtra(tipoPrecioExtra: ITipoPrecioExtra) {
    this.tipoPrecioExtra$.next(tipoPrecioExtra);
  }

  getAll(tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ITipoPrecioExtra[]> {
    let request = (tipoPaginador === TipoPaginadorEnum.offline)
    ? this.urlTiposPrecioExtra
    : `${this.urlTiposPrecioExtra}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, {}).pipe(
         tap( (data: IRespApi )=> {this.totalTiposPrecioExtra$.next( data.total );}),
         tap( (data: IRespApi )=> {this.tiposPrecioExtra$.next( this.mapearTiposPrecioExtra(data['data'] ))}),
         map( (data: IRespApi) =>  this.mapearTiposPrecioExtra(data['data'] )),
         catchError((err: IRespApi) => {
          return this.handleError(err, 'IRequestTiposPrecioExtra');
        })
    );
  }

  mapearTiposPrecioExtra( tipos: ITipoPrecioExtra[] ) {
    return tipos;
  }

  get(id): Observable<ITipoPrecioExtra>{
    return this.http.get(`${this.urlTiposPrecioExtra}/${id}`).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestTipoPrecioExtra');
      })
    );
  }

   /************************************
  * Funciones apoyo                  *
  *************************************/
  resolve() {
    return this.getAll().pipe(
      catchError(err => of(err))
    );
  }

  private handleError(err: IRespApi, idRequest = '') {
    // dialog específico
    console.log('CODIGO ERROR ', err);
    if ( err.codigoError === 422) {
      console.log('Este es el error 422', err.codigoError);
      err.request = idRequest;
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if ( err.data ) {
        if ( typeof err.data === 'string') {
          avisos = err.data;
        }else {
          err.data.forEach(element => {
            if ( element.id === 999 ) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje +  avisos;
    }
    return throwError({'error' : true, 'data': err.data, mensaje });
  }

}
